import createIcon from '../../createIcon';

/**
 * @component @name TrendingDown
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgMThMMTguMjkgMTUuNzFMMTMuNDEgMTAuODNMOS40MSAxNC44M0wyIDcuNDFMMy40MSA2TDkuNDEgMTJMMTMuNDEgOEwxOS43MSAxNC4yOUwyMiAxMlYxOEgxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TrendingDown = createIcon('TrendingDown', [
  [
    'path',
    {
      d: 'M16 18L18.29 15.71L13.41 10.83L9.41 14.83L2 7.41L3.41 6L9.41 12L13.41 8L19.71 14.29L22 12V18H16Z',
      key: '1f0cg3',
    },
  ],
]);

export default TrendingDown;
